import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface Post {
  slug: string;
  title: string;
}

interface PostProps {
  title: string;
  date: string;
  content: string;
  prevPost: Post | null;
  nextPost: Post | null;
  isOldest?: boolean;
}

export function Post({ title, date, content, prevPost, nextPost, isOldest }: PostProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const preElements = document.querySelectorAll(".prose pre");

    preElements.forEach((pre) => {
      const button = document.createElement("button");
      button.className = "copy-btn";
      button.textContent = "⎘";
      button.title = "Copy code";
      
      button.addEventListener("click", async () => {
        const code = pre.querySelector("code");
        if (code) {
          await navigator.clipboard.writeText(code.textContent || "");
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        }
      });

      pre.style.position = "relative";
      pre.appendChild(button);
    });
  }, [content]);

  return (
    <article>
      <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--gold)' }}>{title}</h1>
      <p className="text-sm mb-8" style={{ color: 'var(--muted)' }}>
        {new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>
      <div
        className="prose prose-lg max-w-none"
        dangerouslySetInnerHTML={{ __html: content }}
      />
      {copied && (
        <div className="fixed bottom-4 right-4 px-3 py-2 rounded text-sm" style={{ backgroundColor: 'var(--gold)', color: 'var(--bg)' }}>
          Copied!
        </div>
      )}
      <nav className="mt-16 pt-8 border-t flex justify-between text-sm" style={{ borderColor: 'var(--surface)' }}>
        {isOldest ? (
          <Link to="/" style={{ color: 'var(--gold)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--rose)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--gold)'}>
            ← Home
          </Link>
        ) : prevPost ? (
          <Link to={`/posts/${prevPost.slug}`} style={{ color: 'var(--gold)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--rose)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--gold)'}>
            ← {prevPost.title}
          </Link>
        ) : (
          <span />
        )}
        {nextPost && (
          <Link to={`/posts/${nextPost.slug}`} style={{ color: 'var(--gold)' }} onMouseEnter={e => e.currentTarget.style.color = 'var(--rose)'} onMouseLeave={e => e.currentTarget.style.color = 'var(--gold)'}>
            {nextPost.title} →
          </Link>
        )}
      </nav>
    </article>
  );
}